import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ModalContainer } from '../../../common';

export const ChangeCoverageCoverageModal = ({
  closeCoverageModal,
  onConfirmCoverageModal,
  showCoverageModal,
}) => {
  const { t } = useTranslation('changeCoverage');

  return (
    <ModalContainer
      cancelable={false}
      contentStyle="Change-coverage-coverage-type"
      show={showCoverageModal}
    >
      <h2>{t('options.coverageTypeModal.title')}</h2>

      <div>
        <p>
          <Trans
            components={{ b: <strong /> }}
            i18nKey="options.coverageTypeModal.description"
            ns="changeCoverage"
            t={t}
          />
        </p>

        <p>
          <Trans
            components={{ b: <strong /> }}
            i18nKey="options.coverageTypeModal.footer"
            ns="changeCoverage"
            t={t}
          />
        </p>
      </div>

      <div className="Change-coverage-coverage-type-container-button">
        <button
          className="Change-coverage-coverage-type-confirm"
          onClick={closeCoverageModal}
          type="button"
        >
          {t('options.coverageTypeModal.confirm')}
        </button>

        <button
          className="Change-coverage-coverage-type-cancel"
          onClick={onConfirmCoverageModal}
          type="button"
        >
          {t('options.coverageTypeModal.cancel')}
        </button>
      </div>
    </ModalContainer>
  );
};
